import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';
import {
  getPlatformV1Applications,
  getPlatformV1ApplicationsId,
  patchPlatformV1ApplicationsId,
  postPlatformV1ApplicationsIdApprove,
  postPlatformV1ApplicationsIdNotes,
  postPlatformV1ApplicationsIdReject,
  type AddApplicationNoteRequest,
  type ApproveApplicationRequest,
  type ApproveApplicationResponse,
  type BrandApplication,
  type BrandApplicationList,
  type RejectApplicationRequest,
  type UpdateApplicationRequest,
} from '@nucleus-commerce/api-client/platform';

/** API layer: thin, typed wrappers over the generated client. Responses are bare objects. */
export const applicationsApi = {
  /** `params` as `applicationListParams` builds them: `status`, `q`, `cursor`, `limit`. */
  list: (params: ListParams): Promise<BrandApplicationList> => getPlatformV1Applications(params),
  get: (id: string): Promise<BrandApplication> => getPlatformV1ApplicationsId({ id }),
  addNote: (id: string, body: AddApplicationNoteRequest): Promise<BrandApplication> =>
    postPlatformV1ApplicationsIdNotes({ id }, body),
  update: (id: string, body: UpdateApplicationRequest): Promise<BrandApplication> =>
    patchPlatformV1ApplicationsId({ id }, body),
  approve: (id: string, body: ApproveApplicationRequest): Promise<ApproveApplicationResponse> =>
    postPlatformV1ApplicationsIdApprove({ id }, body),
  reject: (id: string, body: RejectApplicationRequest): Promise<BrandApplication> =>
    postPlatformV1ApplicationsIdReject({ id }, body),
};
